export enum ResourceEnum {
  AccountingAccount = "accounting-account",
  AccountingPosting = "accounting-posting",
  AccountingPostingPosition = "accounting-posting-position",
  AccountingPostingVacantPosition = "vacant-position",
  AccountingTemplate = "accounting-template",
  Product = "product",
  Attribute = "attribute",
  Category = "category",
  Discount = "discount",
  VoucherSerie = "voucher-serie",
  PaymentMethod = "payment-method",
  Document = "document",
  DeliveryMethod = "delivery-method",
  DeliveryService = "delivery-service",
  Voucher = "voucher",
  CustomerGroup = "customer-group",
  Manufacturer = "manufacturer",
  Supplier = "supplier",
  Order = "order",
  SupplierOrder = "supplier-order",
  SupplierOrderPosition = "supplier-order-position",
  Language = "language",
  Country = "country",
  PriceList = "price-list",
  PriceListItem = "price-list-item",
  Customer = "customer",
  ProductGroup = "product-group",
  Marketplace = "marketplace",
  ProcessingTime = "processing-time",
  OwnerProfile = "owner-profile",
  Owner = "owner",
  Condition = "condition",
  Currency = "currency",
  Unit = "unit",
  ConfigNumber = "config-number",
  IntegrationToken = "integration-token",
  Variant = "variant",
  WarehousePlace = "warehouse-place",
  Warehouse = "warehouse",
  User = "user",
  VariantComponent = "variant-component",
  AccountMovement = "account-movement",
  Role = "role",
  StockMove = "stock-move",
  Stock = "stock",
  Vat = "vat",
  IntAttributeValue = "int-attribute-value",
  AttributeValue = "attribute-value",
  SelectionListAttributeValue = "selection-list-attribute-value",
  FloatAttributeValue = "float-attribute-value",
  DateAttributeValue = "date-attribute-value",
  DateTimeAttributeValue = "date-time-attribute-value",
  TextFieldAttributeValue = "text-field-attribute-value",
  B2bGateOrder = "b2b-gate-order",
  B2bGateSupplierOrder = "b2b-gate-supplier-order",
  B2bGateSupplierOrderPosition = "b2b-gate-supplier-order-position",
  B2bGateSupplier = "b2b-gate-supplier",
  BankAccount = "bank-account",
  BankTransaction = "bank-transaction",
  DocumentTemplate = "document-template",
  EmailTemplate = "email-template",
  Contact = "contact",
  MarketingCompany = "marketing-company",
  BrevoAccount = "brevo-account",
  BankSepa = "bank-sepa",
}

export enum LoginRouteSearchParams {
  From = "from",
  Token = "token",
  Password = "password",
  Login = "login",
}

export enum ErpId {
  Kaufbei = "01KEC8S4KYQX4XMYGA4K04BB4E",
  Local = "01J7DYRV23XSYAP2DBASZABQJP",
  Test = "01JVCHYBNQJGRQE793SAH1GHVT",
  Vorlage = "01K8X648B4KKJ8VVHM968HMYG9",
  Supplier = "01K7KE2GAZPQY8VD16FZGWW19C",
  Shop = "01K3K1TTFD4B851V1JBNCMC0YZ",
  Import = "01KFDYA3F81HGBW5CDSWZ85VNM",
  ExonnSupplier = "01K975VS545YKR0VG1X1NVP1FK",
  DemoErp = "01K8X67Q6P3AG2J291G8W4EG2S",
  Demo = "01J7DQ2NBAQWQX11WDYNDSC0QC",
  Connector = "01KC1BFZFHDJ0HWQ99TRZ1WZMN",
}
